module.exports = __webpack_public_path__ + "static/banner-img3-77c1a4c723a89898dbe0dac63e189a0f.png";